import { Component } from '@angular/core';
import { LiveStreamMenuService } from './livestream-menu.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-twitch-chat',
	standalone: false,
	template: `
		<div class="twitch-chat-panel">
			<div class="chat-container">
				<iframe [src]="twitchEmbedUrl"
					width="100%" style="height: 70vh; overflow-y: auto;" frameborder="0" scrolling="yes">
				</iframe>
			</div>
		</div>
	`,
	styleUrls: ['./twitch-chat.component.css'],
	host: {
		'style': 'display: block; height: 100%;'
	}
})
export class TwitchChatComponent {
	public twitchEmbedUrl: unknown;

	constructor(
		public menuService: LiveStreamMenuService,
		private readonly sanitizer: DomSanitizer
	) {
		this.twitchEmbedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.twitch.tv/embed/sromotorsports/chat?parent=${window.location.hostname}&muted=true`);
	}
}
